module.exports = __webpack_public_path__ + "static/media/LogoLight.3f1715fe.svg";